/**
 * 共有・エクスポート及び楽曲メタデータ管理
 */

export const SONG_METADATA = {
  sirius: {
    id: 'sirius',
    title: 'シリウスの心臓',
    engTitle: 'Heart of Sirius',
    no: '#06',
    motif: '白黒の宇宙と月 / モールス信号 / 儚き星の瞬き',
    youtubeUrl: 'https://youtu.be/UKZt1vq8bKI',
    desc: '白黒の夜空に浮かぶ月と天球図。星の瞬きとともにモールス信号と儚い言の葉が宇宙へ響く。'
  },
  waltz: {
    id: 'waltz',
    title: '物語りのワルツ',
    engTitle: "Story's Waltz",
    no: '#03',
    motif: '黄金の蔦とアネモネ / 虹色L字リボン枠 / 白花ワイヤーフレーム渦',
    youtubeUrl: 'https://youtu.be/Kz424oVx9_o',
    desc: '結晶格子の闇に目覚める実験体と、眩い光の中に咲くアネモネ。極彩色のL字リボン枠とデータ世界の白い花弁渦が3拍子で舞い踊る。'
  },
  irohani: {
    id: 'irohani',
    title: 'いろはに咲きて',
    engTitle: 'Irohani Sakite',
    no: '#04',
    motif: '紅黒の扇骨と円窓 / 白銀の茨と花毬 / 朱紅の高架舞台と菱形紙吹雪',
    youtubeUrl: 'https://youtu.be/EiPZenIQZa0',
    desc: '紅と黒の扇骨ストライプに浮かぶ円窓と三日月巴。白銀の茨に淡桃色の花毬が咲き、桃色の火雫が世界を鮮やかな朱紅と菱形紙吹雪の舞台へと染め上げる。'
  },
  hydrangea: {
    id: 'hydrangea',
    title: 'ハイドレンジア',
    engTitle: 'Hydrangea',
    no: '#05',
    motif: '点描球体と多面体 / 四弁ダイヤ格子 / 灰色の紫陽花',
    youtubeUrl: 'https://youtu.be/lqTS5eaEhbI',
    desc: '白と黒、灰色に見出す体温のモノクローム空間。点描の天球を巡る正多面体と、空白を埋める四弁ダイヤ格子・紫陽花の花房が静かに呼吸する。'
  },
  diorama: {
    id: 'diorama',
    title: 'ジオラマドラマ',
    engTitle: 'Diorama Drama',
    no: '#12',
    motif: '不規則な長方形 / 二面性カラー / 断片カードと箱庭テレビ',
    youtubeUrl: 'https://youtu.be/ftCqxjpxdc8',
    desc: '不規則に生える長方形とAnemone I・IIの二面性カラー。記憶の断片カードが舞い、暗闇にぽつねんと置かれた箱庭テレビへ収束する。'
  },
  houseki: {
    id: 'houseki',
    title: 'ヰ世界の宝石譚',
    engTitle: 'Tales of Gems in Isekai',
    no: '#13',
    motif: '蒼碧の宝石と崩壊瓦礫の暴風 / 砕け散る結晶と亀裂モノリス / 閃光クラックとピクセルグリッチ',
    youtubeUrl: 'https://youtu.be/hcqXjcO791s',
    desc: 'ブリリアントカットの宝石群と✕字光芒が舞う中、崩壊したコンクリート瓦礫や鉄骨トラス、黒き亀裂モノリスが暴風となって激突し砕け散る苛烈な宝石譚。'
  },
  dimension: {
    id: 'dimension',
    title: 'ディメンション',
    engTitle: 'Dimension',
    no: '#14',
    motif: '白亜の円柱と螺旋階段 / 深紅のポピーと花影の時計盤 / 大聖堂の光窓と浮遊城塞',
    youtubeUrl: 'https://youtu.be/-x1Tyg2uvVM',
    desc: '黄金の星雲に聳える白亜の円柱と空へ連なる螺旋階段。深紅のポピーが揺れる陽だまりの時計盤と、無数の光窓が輝く大聖堂、星辰の地平線に浮かぶ城塞島が次元を超えて交差する。'
  },
  pandora: {
    id: 'pandora',
    title: 'パンドラコール',
    engTitle: 'Pandora Call',
    no: '#19',
    motif: '黒電話と歯車 / 世⚙️界と裸電球 / 円環歌詞と音の罠',
    youtubeUrl: 'https://youtu.be/mQz2IA56VCo',
    desc: '閑散な夜の廃室に鳴り響く黒電話と裸電球。くり抜かれた「世」の中で赤い歯車が噛み合い、精巧な音の罠と円環の言葉が狂おしく踊る。'
  }
};

export function shareToX(songId, costumeName) {
  const song = SONG_METADATA[songId] || SONG_METADATA.sirius;
  const text = `ヰ世界情緒「${song.title}」をテーマに、ジェネラティブアートを生成しました。\n【衣装モチーフ: ${costumeName}】\n\n`;
  const hashtags = 'ヰ世界情緒,ヰ世界情緒ジェネラティブアート,ISJ_genArt';
  const url = window.location.href;

  const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&hashtags=${encodeURIComponent(hashtags)}&url=${encodeURIComponent(url)}`;
  window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=450');
}
